// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
// @flow

export default {
    ALERT_NOTIFICATION: 'notification',
    ALERT_DEVELOPER: 'developer',
    ALERT_ERROR: 'error',
};
